<div class="table">
  <div class="row header">
    @if (type() !== 'kalp-details') {
      <div class="column">Låntagare</div>
    }

    @if (type() === 'income') {
      <div class="column">Inkomst</div>
      <div class="column">Skattefria inkomster</div>
      <div class="column">Barnbidrag</div>

    }

    @if (type() === 'cost') {
      <div class="column">Skatt</div>
      <div class="column">Studielån</div>
      <div class="column">Övriga kostnader</div>
    }
  </div>
  @for (applicant of this.kalpylator().applicants; track applicant; let i = $index) {
    <div class="row">
      @if (type() !== 'kalp-details') {
        <div class="column first-column">{{ applicant.name }}
          @if (kalpylator().incomes[i].reducedIncome) {
            <span><sup>*</sup></span>
          }
        </div>
      }
      @if (type() === 'income') {
        <div
          class="column">{{ kalpylator().incomes[i].monthlyIncome | number: '1.0-0' : 'sv' }}
        </div>
        <div
          class="column">{{ kalpylator().incomes[i].taxFreeIncome | number: '1.0-0' : 'sv' }}
        </div>
        <div class="column">
          @if (i === 0) {
            <span>{{ kalpylator().monthlyChildrenIncome | number: '1.0-0' : 'sv' }}</span>
          } @else if (i > 0) {
            <span>-</span>
          }
        </div>

      }
      @if (type() === 'cost') {
        <div
          class="column">{{ kalpylator().incomes[i].monthlyTax | number: '1.0-0' : 'sv' }}
        </div>
        <div
          class="column">{{ kalpylator().incomes[i].studyLoan | number: '1.0-0' : 'sv' }}
        </div>
        <div
          class="column">{{ kalpylator().incomes[i].otherCosts | number: '1.0-0' : 'sv' }}
        </div>

      }
    </div>
  }
  <div class="row">
    @if (type() !== 'kalp-details') {
      <div class="column first-column sum">
        Totalt
      </div>
    }
    @if (type() === 'income') {
      <div
        class="column">{{ kalpylator().monthlyIncome - kalpylator().monthlyTaxFreeIncome | number: '1.0-0' : 'sv' }}
        @if (kalpylator().reducedIncome) {
          <span><sup>*</sup></span>
        }
      </div>
      <div
        class="column">{{ kalpylator().monthlyTaxFreeIncome | number: '1.0-0' : 'sv' }}
      </div>
      <div
        class="column">{{ kalpylator().monthlyChildrenIncome | number: '1.0-0' : 'sv' }}
      </div>

    }
    @if (type() === 'cost') {
      <div
        class="column">{{ kalpylator().monthlyIncomeTax | number: '1.0-0' : 'sv' }}
        <sup>*</sup></div>
      <div
        class="column">{{ kalpylator().monthlyStudyLoan | number: '1.0-0' : 'sv' }}
      </div>
      <div
        class="column">{{ kalpylator().monthlyOtherCosts | number: '1.0-0' : 'sv' }}
      </div>
    }
    <!-- if 'kalp-details -->
    @if (type() === 'kalp-details') {
      <div>
        <div class="row">
          <div class="column" [style.min-width.px]="300">Kvar att leva på efter
            boendekostnad
          </div>
          <div class="column">{{
              kalpylator().kalp + kalpylator().monthlyLivingExpense + kalpylator().monthlyChildrenCost
                | number:'1.0-0':'sv'
            }} kr/månad
          </div>
        </div>

        <div class="row">
          <div class="column" [style.min-width.px]="300">
            Budget/levnadskostnader
          </div>
          <div
            class="column">{{ kalpylator().monthlyLivingExpense + kalpylator().monthlyChildrenCost | number:'1.0-0':'sv' }}
            kr/månad
          </div>
        </div>

        <div class="row">
          <div class="column" [style.min-width.px]="300">Överskott/Underskott
          </div>
          <div
            class="column lines">{{ kalpylator().kalp | number:'1.0-0':'sv' }}
            kr/månad
          </div>
        </div>
      </div>
    }

  </div>
  @if (type() === 'cost') {
    <spb-other [kalpylator]="kalpylator()"></spb-other>
  }
  @if (type() === 'income' && kalpylator().reducedIncome) {
    <div><sup>*</sup>Sänkt inkomst på grund
      av {{ this.kalpylator()['parameters'].almostRetiredThreshold }}+ eller
      pensionär yngre än 78 år
    </div>
  }

  @if (type() === 'cost' && kalpylator().incomes[0]) {
    <div><sup>*</sup>
      Inkomstskatt @if (kalpylator().incomes[1]) {
        <span>för huvudlåntagare</span>
      } beräknas genom att tillämpa
      skattetabell {{ kalpylator().incomes[0].taxTable | number:'1.0-0': 'sv' }}
      och
      skattekolumn {{ kalpylator().incomes[0].taxColumn }}.

      @if (type() === 'cost' && kalpylator().incomes[1]) {
        För medlåntagare tillämpas
          skattetabell {{ kalpylator().incomes[1].taxTable | number:'1.0-0': 'sv' }}
        och
          skattekolumn {{ kalpylator().incomes[1].taxColumn }}.
      }
    </div>
  }
  @if (type() !== 'cost') {
    <div class="copy-to-right">
      <spb-copy [copy]="copy"></spb-copy>
    </div>
  }
</div>
